import {useAppSelector} from "../../../../../../redux/hooks";
import {useSongDetailsDisplaySelectedLesson} from "../../hooks/useSongDetailsDisplaySelectedLesson";
import {deviceStore} from "../../../../../../redux/device/deviceStore";


export interface ISongDetailsLessonsListLogic {
  activeLessonId: number;
  groups: string[];
}

export const useSongDetailsLessonsListLogic = (): ISongDetailsLessonsListLogic => {

  const {lessonId: routerLessonId, firstLessonId} = useSongDetailsDisplaySelectedLesson();

  const isMobile = useAppSelector(deviceStore.getDeviceIsMobile);

  const activeLessonId = routerLessonId ??
    (isMobile ? 0 : firstLessonId) ??
    0;

  const groups = [
    `Rookie`,
    `Intermediate`,
    `Advanced`,
  ];
  return {
    groups,
    activeLessonId,
  };
}
